import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class NewsService {
  constructor(public http: HttpClient) {}

  private header = new HttpHeaders({
    'Content-Type': 'application/json',
    'x-api-key': environment.apiKey,
  });
  public getAllNews(): Observable<any> {
    const body = {
      query: `
      query {
        listNews(filter: {visibility: {eq: true}}) {
          items {
            content
            category
            id
            title
            media
            createdAt
          }
        }
      }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public getNews(id:  string): Observable<any> {
    const body = {
      query: `
        query {
          getNews(id: "${id}") {
            category
            content
            createdAt
            id
            title
            media
            visibility
          }
        }
        
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }
}
